import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react'

export const useDesktopMode = () => {
    const desktopMode = useMediaQuery('(min-width:600px)');

    return desktopMode;
}